<div class="enroll">
  <div class="card" *ngIf="loading">
    <p class="page__eyebrow">Device registration</p>
    <p class="enroll__wait"><i class="pi pi-spin pi-spinner" aria-hidden="true"></i> Registering this device…</p>
  </div>

  <div class="card" *ngIf="!loading && deviceName">
    <p class="page__eyebrow">Device registration</p>
    <div class="enroll__ok">
      <span class="enroll__ok-icon" aria-hidden="true">✓</span>
      <h1 class="enroll__title">This device is now registered as “{{ deviceName }}”</h1>
    </div>
    <p class="enroll__lede">
      When someone scans a patient's QR code on this device, the <strong>full document</strong>
      will now be shown — unregistered devices only see the minimal emergency summary.
      The registration is stored on this device only; keep it with your organization.
    </p>
    <a class="btn btn--primary" routerLink="/public-molst-lookup">Go to the QR verify page</a>
  </div>

  <div class="card" *ngIf="!loading && failed">
    <p class="page__eyebrow">Device registration</p>
    <h1 class="enroll__title">This link is invalid or expired</h1>
    <p class="enroll__lede">
      Enrollment links work once and expire after 24 hours. Ask your administrator
      for a new one, then open it on the device you want to register.
    </p>
  </div>
</div>
